<div class="check-email-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Verify Email</span
      >
    </nav>
  </header>

  <mat-card class="check-email-card" appearance="outlined">
    <mat-card-content>
      <p class="step-label">Step 1 of 2</p>
      <h1 class="check-email-card__heading">Verify your email</h1>

      @if (email()) {
        <!-- Email is known — show confirmation + resend button -->
        <p class="check-email-card__email">
          A verification link may be on its way to
          <strong data-testid="check-email-email">{{ email() }}</strong
          >. Please check your inbox.
        </p>

        <div class="or-divider" aria-hidden="true">
          <span class="or-divider__line"></span>
        </div>

        <p class="check-email-card__instruction">
          Also check your spam or junk folder if you don't see the email.
        </p>

        <!-- Resend state: already verified -->
        @if (resendState() === 'already_verified') {
          <div class="status-message status-message--info" role="status">
            Your email is already verified —
            <a [routerLink]="['/auth/login']" class="link">log in here</a>.
          </div>
        }

        <!-- Resend state: success -->
        @if (resendState() === 'sent') {
          <div
            class="status-message status-message--success"
            data-testid="check-email-resend-success"
            role="status"
          >
            Check your inbox — a new link may be on its way.
          </div>
        }

        <!-- Resend state: error -->
        @if (resendState() === 'error') {
          <div class="status-message status-message--error" role="alert">
            Could not resend the email. Please try again in a moment.
          </div>
        }

        <button
          mat-flat-button
          class="full-width"
          data-testid="check-email-resend"
          [disabled]="resendState() === 'sending' || countdown() !== null"
          (click)="onResend()"
        >
          @if (resendState() === 'sending') {
            <mat-spinner diameter="20" />
          } @else if (countdown() !== null) {
            Resend available in {{ countdown() }}s
          } @else {
            Resend verification email
          }
        </button>
      } @else {
        <!-- Email not in navigation state (direct landing or page refresh) — collect it here -->

        <!-- Resend state: already verified -->
        @if (resendState() === 'already_verified') {
          <div class="status-message status-message--info" role="status">
            Your email is already verified —
            <a [routerLink]="['/auth/login']" class="link">log in here</a>.
          </div>
        }

        <!-- Resend state: error -->
        @if (resendState() === 'error') {
          <div class="status-message status-message--error" role="alert">
            Could not send the email. Please try again in a moment.
          </div>
        }

        <form
          class="check-email-card__form"
          [formGroup]="emailForm"
          (ngSubmit)="onSubmitEmail()"
          novalidate
        >
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email address</mat-label>
            <input
              matInput
              type="email"
              autocomplete="email"
              formControlName="email"
              data-testid="check-email-input"
              required
            />
            @if (emailControl.touched && emailControl.hasError('required')) {
              <mat-error>Email is required.</mat-error>
            } @else if (emailControl.touched && emailControl.hasError('email')) {
              <mat-error>Enter a valid email address.</mat-error>
            }
          </mat-form-field>

          <button
            mat-flat-button
            type="submit"
            class="full-width"
            data-testid="check-email-submit"
            [disabled]="resendState() === 'sending' || countdown() !== null"
          >
            @if (resendState() === 'sending') {
              <mat-spinner diameter="20" />
            } @else if (countdown() !== null) {
              Try again in {{ countdown() }}s
            } @else {
              Send verification email
            }
          </button>
        </form>

        <p class="check-email-card__spam-note">
          Already received it? Check your spam or junk folder.
        </p>
      }
    </mat-card-content>
  </mat-card>
</div>
